import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../app/directives/shared.module'
import { c_card_site_plan_v3_component } from './c_card_site_plan_v3.component';
import { tooltip_wrapper_component } from './tooltip-wrapper/tooltip-wrapper.component';
import { NoticeModule } from '../../../../app/modals/notice/notice.module';
import { CloudAIDefaultSettingsMoudle } from '../../../../app/modals/cloud-ai/cloud-ai-default-settings/cloud-ai-default-settings.module';


@NgModule({
  imports: [ CommonModule, FormsModule, SharedModule, NoticeModule, CloudAIDefaultSettingsMoudle ],
  declarations: [ 
    c_card_site_plan_v3_component, tooltip_wrapper_component
  ],
  exports: [c_card_site_plan_v3_component],
})
export class c_card_site_plan_v3_module { }
